export default __webpack_public_path__ + "cdaf3cd43a20c86efa08151219906009.jpg";